"use client";

import { ArrowRight, Layers, Palette, Sofa } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Coord02TheEquipment() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "No 01",
    title: "OPTICAL PRECISION",
    Icon: Palette,
    body: "We utilize diffraction-limited apochromatic refractors and high-resolution CMOS sensors to capture the subtle gradients of the solar corona and distant nebulae with absolute fidelity.",
    italic: "Clarity beyond the atmosphere.",
    offset: "md:translate-y-0"
  }, {
    number: "No 02",
    title: "DATA ACQUISITION",
    Icon: Layers,
    body: "Our workflow integrates narrowband filtering and sub-pixel dithering to isolate specific hydrogen-alpha emissions, revealing the turbulent structures of the solar chromosphere.",
    italic: "Capturing the invisible spectrum.",
    offset: "md:-translate-y-12"
  }, {
    number: "No 03",
    title: "CELESTIAL STAGING",
    Icon: Sofa,
    body: "Advanced equatorial tracking and automated dome synchronization ensure that every photon is perfectly placed, transforming raw data into breathtaking cosmic portraits.",
    italic: "The universe is our canvas.",
    offset: "md:translate-y-12"
  }];
  return;
}